// extracted by mini-css-extract-plugin
module.exports = {"container":"AccountManagementRecordSelect_container__20ADY","label":"AccountManagementRecordSelect_label__1LWqh","disabled":"AccountManagementRecordSelect_disabled__3kbb4"};